import { combineReducers } from 'redux';
import fiasUpdates from './fiasUpdates';

export default combineReducers({
  fiasUpdates
});

export * from './fiasUpdates';



// WEBPACK FOOTER //
// ./Scripts/redux/modules/fiasUpdates/index.js